import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { profile, alert, loading, format_date } from "./CustomComponent.js";
import { withRouter } from "./withRouter.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/manora-report.css";

class AppHeader extends Component {
  componentDidMount() {
    if (!profile) {
      window.location.href = "/";
    }
  }

  Logout = async () => {
    const { t } = this.props;
    if (
      await alert(
        "",
        "warning",
        t("header.logout_confirm_title"),
        t("header.logout_confirm_text"),
        t("header.logout_confirm_button"),
        t("header.logout_cancel_button"),
      )
    ) {
      loading(true);
      localStorage.clear();
      window.location.href = "/";
      loading(false);
    }
  };

  render() {
    const { title, subtitle, activeTab, t, i18n } = this.props;
    const locale = i18n.language;

    return (
      <div>
        <div className="manora-header-bar d-flex flex-wrap justify-content-between align-items-start">
          <div>
            <div className="manora-header-title">{title}</div>
            <div className="manora-header-subtitle">{subtitle}</div>
          </div>
          <div className="d-flex flex-column align-items-end">
            <div className="d-flex mb-2" style={{ gap: 4, background: "rgba(255,255,255,0.15)", borderRadius: 999, padding: 4 }}>
              {["en", "th", "my"].map((code) => (
                <button
                  key={code}
                  type="button"
                  className={`manora-pill ${locale === code ? "active" : ""}`}
                  onClick={() => i18n.changeLanguage(code)}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
            <small style={{ color: "#e4d9fb" }}>{format_date(new Date(), "d mmmm yyyy")}</small>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-between align-items-center px-3 py-3" style={{ gap: 12 }}>
          <div className="d-flex" style={{ gap: 10 }}>
            <button
              type="button"
              className={`manora-tab-pill ${activeTab === "stock" ? "active" : ""}`}
              onClick={() => {
                // ใช้ client-side navigation แทน window.location.href กันหน้ารีโหลดทั้งหน้า
                // (เดิมสลับแท็บทีต้องโหลด JS bundle + ดึงข้อมูล dropdown ใหม่หมดทุกครั้ง)
                this.props.router.navigate("/stock-onhand");
              }}
            >
              📦 {t("header.stock_tab")}
            </button>
            <button
              type="button"
              className={`manora-tab-pill ${activeTab === "reports" ? "active" : ""}`}
              onClick={() => {
                this.props.router.navigate("/reports");
              }}
            >
              📊 {t("header.reports_tab")}
            </button>
            {/* (#01.2) จัดการ/ยกเลิก Label ที่พิมพ์เกิน */}
            <button
              type="button"
              className={`manora-tab-pill ${activeTab === "labels" ? "active" : ""}`}
              onClick={() => {
                this.props.router.navigate("/labels");
              }}
            >
              🏷️ {t("header.labels_tab")}
            </button>
          </div>
          <button type="button" className="manora-logout-btn" onClick={() => this.Logout()}>
            🗑 {t("header.logout")}
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslation()(AppHeader));
